import { setup } from '../config';

const { cdnUrlBase, cecDataMode } = setup;

// central election comission
const fetchDataFromCEC = () => {
  return new Promise((resolve, reject) => {
    const url = `${cdnUrlBase}/${cecDataMode}.json`;
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      })
  })
}


export {
  fetchDataFromCEC,
}
